<template>
    <div>
        <template v-if="advancementLoaded">
            <div class="card jumbotron-card p-4 rounded-more user-select-none">
                <div class="d-flex flex-row justify-content-between">
                    <div class="d-flex flex-column">
                        <div class="description-section d-flex flex-column gap-2x text-white flex-1">
                            <h2 class="text-xl text-bold">Want some EXTRA Income ?</h2>
                            <h3 class="text-lg text-bold">
                                Invite more friends to get <br />points by sending your
                                referrral code
                            </h3>
                        </div>

                        <template v-if="requestUpLevelButtonShown">
                            <button @click="handleUplevel" :disabled="submitting" class="btn btn-primary px-5 py-3">
                                <span v-show="submitting" class="spinner-border spinner-border-sm"></span>
                                <span>Request UP Level</span>
                            </button>
                        </template>

                        <template v-if="waitingVerificationButtonShown">
                            <button disabled class="btn btn-primary px-5 py-3">Waiting Verification</button>
                        </template>
                    </div>

                    <div class="illustration-section">
                        <img src="@/assets/dash_picture.png" class="img-fluid" alt="" />
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <skeleton-jumbotron-card />
        </template>
    </div>
</template>

<style scoped>
    .jumbotron-card{
        background-color: #ec0c13;
    }
</style>

<script>
import swal from 'sweetalert';
import axios from "axios";
import SkeletonJumbotronCard from './SkeletonJumbotronCard.vue';

export default {
  components: { SkeletonJumbotronCard },
    name : "JumbotronCard",
    props : {
        ib : {
            type : Object,
            default : function(){
                return {
                    level : undefined
                }
            }
        }
    },
    data(){
        return {
            submitting : false,
            ibAccount : this.ib,
            advance : new Promise(function(){})
        }
    },
    computed : {
        advancementLoaded(){
            return !(this.advance instanceof Promise)
        },
        requestUpLevelButtonShown(){
            if( !this.ibAccount?.level ){
                return false
            }

            if( this.ibAccount.level !== 'MASTER_IB' ){
                if( this.advance?.advancement_status !== 'PENDING' ){
                    return true
                }
            }

            return false
        },
        waitingVerificationButtonShown(){
            if( !this.ibAccount?.level ){
                return false
            }

            if( this.ibAccount.level !== 'MASTER_IB' ){
                if( this.advance?.advancement_status === 'PENDING' ){
                    return true
                }
            }

            return false
        }
    },
    async mounted(){
        let advance = await this.get_advancement()
        this.advance = { ...this.advance, ...advance }
    },
    methods : {
        /**
         * Method untuk request advancement terakhir
         */
        async get_advancement(){
            let resp = await axios.get(`investor/${localStorage.user_id}/ib/advancement/?limit=1`)
            
            if( resp?.data?.data ){
                if( Array.isArray(resp.data.data) ){
                return resp.data.data[0]
                }
            }
            
            return undefined
        },

        /**
         * Method untuk handling request up level
         */
        async handleUplevel(){
            this.submitting = true

            try{
                let resp = await axios.post(`investor/${localStorage.user_id}/ib/advancement/`, {})

                swal('Success', resp.data.message, 'success', {
                    button: "OK"
                })

                this.advance = await this.get_advancement()
            }catch( err ){
                swal('Sorry,,,,', err.response.data.message, 'error', { button: "OK" })
            }finally{
                this.submitting = false
            }
        }
    }
}
</script>
